// ;(function () {
//   "use strict"

//   var forms = document.querySelectorAll(".needs-validation")

//   Array.prototype.slice.call(forms).forEach(function (form) {
//     form.addEventListener(
//       "submit",
//       function (event) {
//         if (!form.checkValidity()) {
//           event.preventDefault()
//           event.stopPropagation()
//           setTimeout(function () {
//             let firstError = $(".invalid-feedback:visible:first").attr("data-info")
//             track("Form", "Submit Error " + firstError, {form: {id: "newsletter-form"}}, $(this))
//           }, 1000)
//         } else {
//           track("Form", "Submit Successful", {form: {id: "newsletter-form"}}, $(this))
//         }

//         form.classList.add("was-validated")
//       },
//       false
//     )
//   })
// })()

$(function () {

  const newsletterForm = $('#newsletterform')
  if (!newsletterForm.length) return

  const ANALYTICS_FORM_OBJECT = { form: { id: 'newsletter-form' } }
  const ANALYTICS_CATEGORY = 'Form'
  const CATEGORY_MAPPING = {
    '999_1197_1': 'MTB',
    '999_1197_4': 'Road',
    GRV: 'Gravel',
    EMB: 'E-bike MTB',
    ECT: 'E-Bike City/Trekking',
  }
  trackForm('Viewed', newsletterForm)

  // Since we use anchor taggs as buttons :)
  $(".submit-btn").on("click", function (e) {
    e.preventDefault()
    $(".inputRadio").each(function () {
      if ($(this).is(":invalid")) {
        document.getElementById("invalidRadio").style.display = "block"
      }
    })
    $(".inputCheck").each(function () {
      var numberNotChecked = $('.inputCheck:not(":checked")').length
      if (numberNotChecked === 5) {
        element.classList.add("errorCheck")
        document.getElementById("invalidCheck").style.display = "block"
      }
    })
    newsletterForm.trigger("submit")
  })
  newsletterForm.on("submit", function (e) {
    e.preventDefault()
    if (!this.checkValidity()) {
      e.stopImmediatePropagation()
      let firstError = $(".invalid-feedback:visible:first").attr("data-info")
      trackForm('Submit Error ' + firstError, $(this))
    } else {
      trackForm('Submit Successful', $(this))
    }

    this.classList.add("was-validated")
  })

  var inputRadio = document.querySelectorAll("input[name=gender]")

  for (var i in inputRadio) {
    inputRadio[i].onchange = function () {
      if (this.checked) {
        document.getElementById("invalidRadio").style.display = "none"
        return
      }
    }
  }

  var inputCheck = document.querySelectorAll(".inputCheck")
  var element = document.getElementById("groupCheck")

  for (var i in inputCheck) {
    inputCheck[i].onchange = function () {
      if (this.checked) {
        document.getElementById("invalidCheck").style.display = "none"
        element.classList.remove("errorCheck")
        return
      }
    }
  }

  $(".submit-btn").on("click", function () {
    $(".inputRadio").each(function () {
      if ($(this).is(":invalid")) {
        document.getElementById("invalidRadio").style.display = "block"
      }
    })
    $(".inputCheck").each(function () {
      var numberNotChecked = $('.inputCheck:not(":checked")').length
      if (numberNotChecked === 5) {
        element.classList.add("errorCheck")
        document.getElementById("invalidCheck").style.display = "block"
      }
    })
  })

  /* Analytics */
  var loggedSteps = []
  newsletterForm.on('blur', 'input.form-control', function () {
    let $this = $(this)
    let type = $this.attr('name')
    let value = $this.val()
    // In case the user leaves the field empty. They will get an error on submission so should be ignored
    if (value) {
      switch (type) {
        case 'emailAddress':
          trackForm('Field Email Filled', $this)
          trackStep(1, $this)
          break
        case 'firstName':
          trackForm('Field Firstname Filled', $this)
          trackStep(2, $this)
          break
        case 'lastName':
          trackForm('Field Lastname Filled', $this)
          trackStep(3, $this)
          break
        default:
          break
      }
    }
  })

  newsletterForm.on('change', 'select.form-select', function () {
    let $this = $(this)
    let type = $this.attr('name')
    let value = $this.val()
    // In case user change to empty field. They will get an error on submission so should be ignored
    if (value) {
      switch (type) {
        case 'country':
          trackForm(`Field Country ${value} Selected`, $this)
          trackStep(4, $this)
          break
        case 'language':
          trackForm(`Field Language ${value} Selected`, $this)
          trackStep(5, $this)
          break
        default:
          break
      }
    }
  })

  newsletterForm.on('change', 'input[type=radio][name=gender]', function () {
    let $this = $(this)
    let value = $this.val()
    switch (value) {
      case 'B':
        trackForm(`Field Gender Both Checked`, $this)
        break
      case 'F':
        trackForm(`Field Gender Female Checked`, $this)
        break
      case 'M':
        trackForm(`Field Gender Male Checked`, $this)
        break
      default:
        // In case API returned a different value for a specific locale just log it as is
        trackForm(`Field Gender ${value} Checked`, $this)
        break
    }
    trackStep(6, $this)
  })

  newsletterForm.on('change', 'input[type=checkbox][name=preference]', function () {
    // Only run on checking
    if (this.checked) {
      let $this = $(this)
      // let value = $this.val();
      // let category = CATEGORY_MAPPING[value] === undefined ? value : CATEGORY_MAPPING[value];
      // trackForm(`Field Category ${category} Checked`, $this);
      trackStep(7, $this)
      let checkedPerferences = []
      $('input[type=checkbox][name=preference]').each((index, element) => {
        if (element.checked) {
          checkedPerferences.push(CATEGORY_MAPPING[element.value])
        }
      })
      if (checkedPerferences.length > 1) {
        track(ANALYTICS_CATEGORY, 'Field Category Multiple Checked', { form: { id: 'newsletter-form', category: checkedPerferences.join(',') } }, $this)
      } else {
        trackForm(`Field Category ${checkedPerferences[0]} Checked`, $this)
      }
    }
  })

  newsletterForm.on('change', 'input[type=checkbox][name=optIn]', function () {
    // Only run on checking
    if (this.checked) {
      trackForm(`Field Terms Checked`, $(this))
      trackStep(8, $(this))
    }
  })

  function trackStep(step, element) {
    if (!loggedSteps.includes(step)) {
      trackForm(`Step ${step} Reached`, element)
      loggedSteps.push(step)
    }
  }

  function trackForm(action, element) {
    track(ANALYTICS_CATEGORY, action, ANALYTICS_FORM_OBJECT, element)
  }

})
